import * as React from "react"
import * as Immutable from 'immutable'
import { BooleansOf } from "../../../utils/types";
import { snakeCase } from "lodash";
import { SaleAdvert } from "../../../types/types";
import BooleanList from "../../shared/advert/BooleanList";

type Props = {
  advert: SaleAdvert
  booleans: Immutable.OrderedSet<BooleansOf<SaleAdvert>>
}

export default (props: Props) : JSX.Element => (
  <BooleanList
    advert={props.advert}
    booleans={props.booleans}
    translate={(s) => I18n.t(`activerecord.attributes.sale_advert.${snakeCase(s)}`)}
  />
)
